import { useEffect, React } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Providers } from "./components/providers/Providers";
import AppRoutes from "./routes/AppRoutes";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { attachDateInputGuard } from "./utils/global/dateInputGuard.js";
function App() {
  useEffect(() => {
    attachDateInputGuard();
  }, []);


  return (
    // <ErrorBoundary>
    <Providers>
      <AppRoutes />
    </Providers>
    // </ErrorBoundary>
  );
}

export default App;
